/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFormLayout = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 16v6H8v-6zm-2 2H10v2h10zM6 18v2H2v-2zm16-9v6H8V9zm-2 2H10v2h10zM6 11v2H2v-2zm16-9v6H8V2zm-2 2H10v2h10zM6 4v2H2V4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgFormLayout as FormLayout };
